import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { LeafTranslateLoader } from '../translations/leaf-translate.loader';

import { Router } from '@angular/router';

// custom TranslateLoader while using AoT compilation
export function createTranslateLoader(http: HttpClient) : TranslateLoader {
  return new LeafTranslateLoader(http, '/assets/i18n/', '.json');
}
